import React from 'react';
import { FiMenu } from 'react-icons/fi';

/** Phone-width header: hamburger that opens the navigation drawer + logo. Hidden ≥768px by CSS. */
function AppTopBar({ onMenu, drawerOpen }) {
  return (
    <header className='app-topbar'>
      <button
        type='button'
        className='app-topbar__menu'
        aria-label='Open navigation'
        aria-controls='app-sidebar'
        aria-expanded={drawerOpen}
        onClick={onMenu}
        data-testid='app-topbar-menu'
      >
        <FiMenu aria-hidden='true' />
      </button>
      <img className='app-topbar__logo' alt='C2 Privacy Platform' src='/c2_platform_white.png' />
    </header>
  );
}

export default AppTopBar;
